
import { Tooltip } from "../Tooltip"
import { Card, CardHeader, CardTitle } from "../Card"
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../Table"
import { api } from "~/utils/api"
import { startCase } from "lodash"

const CollectionsInformationOverview = () => {
  const { data: collections } = api.healthCheck.collections.useQuery()

  return (
    <Card>
      <CardHeader>
        <CardTitle>Information about collections</CardTitle>
      </CardHeader>
      <Table>
        <TableHeader>
          <TableRow className="text-left text-sm font-normal">
            <TableHead>Company</TableHead>
            <TableHead># of collections</TableHead>
            <TableHead># of SKUs in a collection</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {collections?.length ? (
            collections.map((row) => (
              <TableRow key={row.orgId}>
                <TableCell>
                  <Tooltip title={`Org ID: ${row.orgId}`}>
                    <div>{startCase(row.orgId)}</div>
                  </Tooltip>
                </TableCell>
                <TableCell>{row.collections}</TableCell>
                <TableCell>{row.skus}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell className="text-center italic" colSpan={3}>
                No collections have been created on companies
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Card>
  )
}

export default CollectionsInformationOverview
